import * as React from 'react'

import './Modal.css'

import { Tool } from '../../Api/Tools';
import { ToolsManager } from '../ToolsManager';
import ExternalLink from '../Elements/ExternalLink';
import TimeInput from '../Elements/TimeInput';
import { ToolInstance } from '../ToolInstance';

interface IModalProps {
    onOpen?: () => void;
    onClose?: () => void;
}

interface IModalState {
    isActive: boolean;

    toolInstance?: ToolInstance;

    name: string;
    tags: string[];

    shortDescription: string;
    sources: string[];

    timeInput: string;
}

class Modal extends React.Component<IModalProps, IModalState> {
    private modalCoverRef: React.RefObject<HTMLDivElement> = React.createRef();

    public constructor(props: any) {
        super(props);

        this.state = {
            isActive: false,

            toolInstance: new ToolInstance('', '', 0),

            name: "",
            shortDescription: "",
            sources: [],

            tags: [],

            timeInput: ''
        };
    }

    public render() {
        return (
            <div className={"Modal-Cover" + (this.state.isActive ? "" : " Modal-Cover--inactive")} tabIndex={-1} onKeyDown={this.keyPressed} ref={this.modalCoverRef}>
                <div className="Modal">
                    <div className="Modal__header">
                        <div className="Modal__header__content">
                            <div className="Modal__header__name">{this.state.name}</div>
                            <div className="Modal__header__controls">
                                <i className="Modal__close material-icons" onClick={this.closeClicked}>close</i>
                            </div>
                        </div>

                         <div className="Modal__header__tag-container">
                            {this.renderTags()}
                         </div>
                    </div>
                    <div className="Modal__body">
                        <div className="Modal__primary">
                            <div className="Modal__information">
                                <div className="Modal__description">
                                    {this.state.shortDescription}
                                </div>
                                <div className="Modal__more-info">
                                    <ExternalLink sizeModifier="large" source={this.state.sources[0]} />
                                    <div className="Modal__sub">MORE INFORMATION</div>
                                </div>
                            </div>

                            <div className="Modal__time">
                                <i className="Modal__time__icon material-icons">schedule</i>
                                <TimeInput
                                    className="Modal__time__input"
                                    time={this.state.toolInstance!.time}

                                    onChange={this.timeInputChanged}
                                    />
                            </div>
                        </div>

                        <div className="Modal__secondary">
                            {this.renderMoreSources()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidUpdate(prevProps: IModalProps, prevState: IModalState) {
        if(!prevState.isActive && this.state.isActive) {
            this.modalCoverRef.current!.focus();

            if (this.props.onOpen) {
                this.props.onOpen();
            }
        }

        if(prevState.isActive && !this.state.isActive) {
            if (this.props.onClose) {
                this.props.onClose();
            }
        }
    }

    public open(toolInstance: ToolInstance) : void {
        if(!toolInstance) {
            return;
        }

        const tool: Tool | undefined = ToolsManager.getTool(toolInstance.toolId);
        if(!tool) {
            return;
        }

        if(tool) {
            this.setState({
                isActive: true,

                toolInstance,

                name: tool.name,
                tags: tool.tags,

                shortDescription: tool.shortDescription,
                sources: tool.sources
            });
        } /* does nothing if the id is corrupted, luckily */
    }

    public close() : void {
        this.setState({
            isActive: false
        });
    }

    private renderTags() {
        const buffer: any = [];

        for(const tag of this.state.tags) {
            buffer.push(
                <div className="Modal__tag Modal__tag--blue" key={"modal_"+tag}>
                    <span className="Modal__tag__name">{tag}</span>
                </div>
            );
        }

        return buffer;
    }

    private renderMoreSources() {
        const buffer: any = [];

        for(let sourceIndex = 1;sourceIndex < this.state.sources.length;++sourceIndex) {
            const theSource: string = this.state.sources[sourceIndex];
            buffer.push(
                <ExternalLink sizeModifier="small" source={theSource}  key={theSource} />
            );
        }

        return buffer;
    }

    private closeClicked = () : void => {
        this.close();
    };

    private keyPressed = (event: React.KeyboardEvent) : void => {
        if(event.key === "Escape" || event.key === " ") {
            this.close();

            event.preventDefault();
        }
    }

    private timeInputChanged = (newValue: number | string) : void => {
        if (this.state.toolInstance) {
            console.log(newValue);
            this.state.toolInstance.setTime(newValue);
            this.setState(this.state);
        }
    };
}

export default Modal;



// WEBPACK FOOTER //
// ./src/App/Modal/Modal.tsx